import React, { Component } from 'react';
import { autoResoveTimer } from '../../../images/images';

export default class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = { seconds: 0, minutes: 0, timer: '00:00', isExpired: false };
    this.timer = 0;
  }

  componentDidMount = () => {
    const { timestamp } = this.props;
    this.getTime(timestamp);
    this.startTimer();
  };

  componentWillUnmount = () => {
    clearInterval(this.timerID);
  };

  getMintSec = (distance) => {
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (minutes < 0) {
      this.setState({
        isExpired: true,
      });
    }
    let obj = {
      minutes: minutes < 10 ? `0${minutes}` : minutes,
      seconds: seconds < 10 ? `0${seconds}` : seconds,
    };
    return obj;
  };

  getTime(timestamp) {
    let now = new Date().getTime();
    let distance = timestamp - now;

    let getTimeSlot = this.getMintSec(distance);
    let minutes = getTimeSlot.minutes,
      seconds = getTimeSlot.seconds;

    this.setState({
      timer: `${minutes}: ${seconds}`,
    });
  }

  startTimer = () => {
    const { timestamp, everyMinuteHandler } = this.props;
    let str = '';
    // Update the count down every 1 second
    this.timerID = setInterval(() => {
      let now = new Date().getTime();
      let distance = timestamp - now;

      if (distance < 0) {
        clearInterval(this.timerID);
        return;
      }

      let getTimeSlot = this.getMintSec(distance);
      let minutes = getTimeSlot.minutes,
        seconds = getTimeSlot.seconds;

      str = `${minutes} : ${seconds}`;
      this.setState({
        timer: str,
      });

      if (Number(seconds) === 0 && typeof everyMinuteHandler !== 'undefined') {
        everyMinuteHandler();
      }
    }, 1000);
  };

  render() {
    const { timer, isExpired } = this.state;
    const { type = 'regular' } = this.props;
    let fontStyle = {
      fontWeight: type === 'bold' ? 'bold' : 400,
    };

    return (
      <div className='autoResolveTimerWrapper'>
        <div className='timerIcon'>
          <img src={autoResoveTimer} alt='' />
        </div>
        <div className='ml5 content'>
          {isExpired ? (
            'Resolved '
          ) : (
            <>
              <p className='tiny'>RESOLVE IN</p>
              <p className='dark timer'>
                <span>
                  <span style={fontStyle}>{`${timer} mins`}</span>
                </span>
              </p>
            </>
          )}
        </div>
      </div>
    );
  }
}
